var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "disabled": _vm.loading,
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "display-1 justify-center mb-4 mt-n3"
  }, [_vm._v(" " + _vm._s(_vm.isEditMode ? "Edit storage" : "Add storage") + " ")]), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_vm.isEditMode ? _c('div', {
    staticClass: "storage-info-header mb-4 pa-4 rounded"
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_vm.actionsData.icon ? _c('img', {
    staticClass: "mr-4",
    attrs: {
      "src": _vm.getStorageImg(_vm.actionsData.icon),
      "height": "48",
      "width": "48"
    }
  }) : _vm._e(), _c('div', [_c('div', {
    staticClass: "font-weight-bold text-h6"
  }, [_vm._v(_vm._s(_vm.actionsData.name))]), _c('div', {
    staticClass: "text-caption grey--text"
  }, [_vm._v(_vm._s(_vm.actionsData.bucket))])])])]) : _vm._e(), _vm.isEditMode ? [_c('v-text-field', {
    staticClass: "mb-4",
    attrs: {
      "value": _vm.actionsData.region,
      "disabled": "",
      "filled": "",
      "label": "Region"
    }
  }), _c('v-text-field', {
    staticClass: "mb-4",
    attrs: {
      "value": _vm.actionsData.endpoint,
      "disabled": "",
      "filled": "",
      "label": "Endpoint"
    }
  }), _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "text-subtitle-2 mb-2"
  }, [_vm._v("What would you like to edit?")]), _c('v-btn-toggle', {
    staticClass: "full-width-toggle",
    attrs: {
      "mandatory": ""
    },
    model: {
      value: _vm.editMode,
      callback: function callback($$v) {
        _vm.editMode = $$v;
      },
      expression: "editMode"
    }
  }, [_c('v-btn', {
    staticClass: "flex-grow-1 text-transform-none",
    attrs: {
      "value": "status"
    }
  }, [_vm._v(" Status ")]), _c('v-btn', {
    staticClass: "flex-grow-1 text-transform-none",
    attrs: {
      "value": "credentials"
    }
  }, [_vm._v(" Credentials ")])], 1)], 1), _vm.editMode === 'status' ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "text-subtitle-2 mb-2"
  }, [_vm._v("Status")]), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "row": ""
    },
    model: {
      value: _vm.formValues.status,
      callback: function callback($$v) {
        _vm.$set(_vm.formValues, "status", $$v);
      },
      expression: "formValues.status"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Active",
      "value": 1
    }
  }), _c('v-radio', {
    attrs: {
      "label": "Inactive",
      "value": 0
    }
  })], 1), _vm.formValues.status === 0 ? _c('div', {
    staticClass: "text-caption grey--text"
  }, [_vm._v(" Inactive storage cannot be used for new apps or releases ")]) : _vm._e()], 1) : _vm._e(), _vm.editMode === 'credentials' ? [_c('v-alert', {
    staticClass: "mb-4",
    attrs: {
      "type": "warning",
      "dense": "",
      "text": ""
    }
  }, [_c('strong', [_vm._v("Important:")]), _vm._v(" Before saving, we'll validate that the new credentials have access to the bucket \"" + _vm._s(_vm.actionsData.bucket) + "\". Make sure the credentials have read/write permissions. ")]), _c('v-text-field', {
    staticClass: "mb-4",
    attrs: {
      "error-messages": _vm.keyError,
      "filled": "",
      "label": "Access Key",
      "placeholder": "Enter new access key"
    },
    model: {
      value: _vm.formValues.key,
      callback: function callback($$v) {
        _vm.$set(_vm.formValues, "key", $$v);
      },
      expression: "formValues.key"
    }
  }), _c('v-text-field', {
    staticClass: "mb-4",
    attrs: {
      "error-messages": _vm.secretError,
      "filled": "",
      "label": "Secret Key",
      "placeholder": "Enter new secret key",
      "type": "password"
    },
    model: {
      value: _vm.formValues.secret,
      callback: function callback($$v) {
        _vm.$set(_vm.formValues, "secret", $$v);
      },
      expression: "formValues.secret"
    }
  })] : _vm._e()] : [_c('v-select', _vm._b({
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: 'required',
      expression: "'required'"
    }],
    staticClass: "mb-4",
    attrs: {
      "item-disabled": _vm.disableItem,
      "items": _vm.providerList,
      "menu-props": {
        offsetY: true
      },
      "append-icon": "mdi-chevron-down",
      "attach": "",
      "filled": "",
      "item-text": "name",
      "item-value": "id",
      "placeholder": "Select Providers"
    },
    on: {
      "focusin": function focusin($event) {
        $event.preventDefault();
        return _vm.getProviderList.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "d-flex align-center fill-width"
        }, [_c('v-card', {
          staticClass: "transparent d-flex justify-center align-center my-2 mr-4",
          staticStyle: {
            "width": "32px"
          },
          attrs: {
            "disabled": item.status !== 1,
            "flat": "",
            "tile": ""
          }
        }, [item.icon ? _c('img', {
          attrs: {
            "src": item.icon ? _vm.getStorageImg(item.icon) : null,
            "height": "32"
          }
        }) : _vm._e()]), _vm._v(" " + _vm._s(item.name) + " "), _c('v-spacer'), item.status === 2 ? _c('v-chip', {
          staticClass: "radius-10 bold-text px-3",
          staticStyle: {
            "height": "26px",
            "padding-bottom": "2px"
          }
        }, [_vm._v(" In beta ")]) : _vm._e(), item.status === 3 ? _c('v-chip', {
          staticClass: "radius-10 bold-text px-3",
          staticStyle: {
            "height": "26px",
            "padding-bottom": "2px"
          }
        }, [_vm._v(" Soon ")]) : _vm._e(), item.status === 4 ? _c('v-chip', {
          staticClass: "radius-10 bold-text px-3",
          staticStyle: {
            "height": "26px",
            "padding-bottom": "2px"
          }
        }, [_vm._v(" Future ")]) : _vm._e()], 1)];
      }
    }, {
      key: "no-data",
      fn: function fn() {
        return [_c('div', {
          staticClass: "pa-4"
        }, [_vm.storageLoading ? _c('div', {
          staticClass: "d-flex align-center justify-center"
        }, [_c('ContentLoader', {
          attrs: {
            "size": "25"
          }
        })], 1) : _c('div', [_vm._v("No data available")])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.formValues.s3_id,
      callback: function callback($$v) {
        _vm.$set(_vm.formValues, "s3_id", $$v);
      },
      expression: "formValues.s3_id"
    }
  }, 'v-select', _vm.veeValidate('Providers', 'Providers'), false)), _c('v-text-field', _vm._b({
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: 'required',
      expression: "'required'"
    }],
    staticClass: "mb-4",
    attrs: {
      "disabled": !_vm.formValues.s3_id,
      "filled": "",
      "placeholder": "Enter Key"
    },
    model: {
      value: _vm.formValues.key,
      callback: function callback($$v) {
        _vm.$set(_vm.formValues, "key", $$v);
      },
      expression: "formValues.key"
    }
  }, 'v-text-field', _vm.veeValidate('Key', 'Key'), false)), _c('v-text-field', _vm._b({
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: 'required',
      expression: "'required'"
    }],
    staticClass: "mb-4",
    attrs: {
      "disabled": !_vm.formValues.s3_id,
      "filled": "",
      "placeholder": "Enter Secret"
    },
    model: {
      value: _vm.formValues.secret,
      callback: function callback($$v) {
        _vm.$set(_vm.formValues, "secret", $$v);
      },
      expression: "formValues.secret"
    }
  }, 'v-text-field', _vm.veeValidate('Secret', 'Secret'), false))]], 2), _c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "py-7 px-10 text-transform-none",
    attrs: {
      "disabled": !_vm.isFormValid,
      "loading": _vm.loading,
      "outlined": _vm.$vuetify.theme.dark,
      "color": "primary",
      "x-large": ""
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_c('span', {
    staticClass: "font14"
  }, [_vm._v(" " + _vm._s(_vm.isEditMode ? "Update" : "Add") + " ")])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }